import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { url: String }

  markSeen() {
    if (!this.hasUrlValue) return

    fetch(this.urlValue, {
      method: "PATCH",
      headers: {
        "Accept": "text/vnd.turbo-stream.html",
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content
      }
    })
    .then(r => r.text())
    .then(html => Turbo.renderStreamMessage(html))
    .catch(() => {}) // badge update is non-critical
  }
}
